module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-splitter",
    style: ({
      cursor: _vm.cursor,
      userSelect: _vm.userSelect,
      flexDirection: _vm.flexDirection
    }),
    on: {
      "mouseup": _vm.onUp,
      "mousemove": _vm.onMouseMove,
      "touchmove": _vm.onMove,
      "touchend": _vm.onUp
    }
  }, [(_vm.showLeft) ? _c('div', {
    staticClass: "left-pane splitter-pane",
    style: (_vm.leftPaneStyle)
  }, [_vm._t("left-pane")], 2) : _vm._e(), _vm._v(" "), (_vm.showLeft && _vm.showRight) ? _c('div', {
    staticClass: "splitter",
    class: {
      active: _vm.active
    },
    style: (_vm.splitterStyle),
    on: {
      "mousedown": _vm.onDown,
      "click": _vm.onClick,
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.onDown($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRight) ? _c('div', {
    staticClass: "right-pane splitter-pane",
    style: (_vm.rightPaneStyle)
  }, [_vm._t("right-pane")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19b916da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/splitter/Splitter.vue
// module id = 206
// module chunks = 5